/**
 * An error whose message the UI has already shown to the user, thrown to stop
 * a mutation or flow. It is the expected outcome of a user action, not a bug,
 * so it is never reported to Sentry.
 *
 * @example
 * ```ts
 * if (hasError) {
 *   setError(message);
 *   throw new UserFacingError(message);
 * }
 * ```
 */
export class UserFacingError extends Error {
  constructor(message = "") {
    super(message);
    Object.setPrototypeOf(this, UserFacingError.prototype);
    this.name = "UserFacingError";
  }
}
